import { TabsList } from '~components/atoms/Tabs';
import { BETSLIP_HISTORY_TABS_LIST } from '~components/molecules/BetslipHistorySection/constants';

export const BetslipHistoryTabs = () => (
  <TabsList uppercase tabs={BETSLIP_HISTORY_TABS_LIST} />
);
